export const headerIconButtonClass =
  "relative flex items-center justify-center size-9 shrink-0 rounded-[6px] bg-transparent text-white " +
  "hover:bg-white/15 data-[state=open]:bg-white/15 data-[selected=true]:bg-white/15 transition-colors cursor-pointer " +
  "outline-none focus-visible:ring-2 focus-visible:ring-white/80";
